export default __webpack_public_path__ + "static/media/TheElements _10.08e43e0d.png";